module.exports = __webpack_public_path__ + "static/media/bug.ee1b69d6.jpg";